import { Reveal } from "./Reveal";
import { BorderBeam } from "./border-beam";

type Props = {
  lines: readonly string[] | string[];
  cta: string;
  onCTA: () => void;
  dark?: boolean;
  variant?: "primary" | "gold";
};

/**
 * Bloco de chamada usado entre seções (Dor, Trilhas, Resultados, etc.).
 * Primeira linha vira o "lead" (display serif), demais ficam menores.
 */
export function CTABand({ lines, cta, onCTA, dark = false, variant = "primary" }: Props) {
  return (
    <Reveal className={`ctaband ${dark ? "on-dark" : ""}`}>
      {lines.map((line, i) => (
        <p key={i} className={`ctaband-line ${i === 0 ? "lead" : ""}`}>
          {line}
        </p>
      ))}
      <button
        className={`btn btn-${variant === "gold" ? "gold" : "primary"} btn-lg ctaband-btn btn-beam btn-beam-${variant === "gold" ? "gold" : "primary"}`}
        onClick={onCTA}
      >
        <BorderBeam />
        {cta} <span className="arr">→</span>
      </button>
    </Reveal>
  );
}
